import React from "react";
// import { Link } from "gatsby";
import carImage from "../assets/img/city-car.jpg";
import Header from "../components/appComponents/Header";

const BecomeAHost = () => {
  return (
    <div
      style={{
        width: "100vw",
        maxWidth: "100vw",
        minHeight: "100vh",
        overflowX: "hidden",
        overflowY: "auto",
        position: "relative",
        background: "#09080F",
        backgroundImage:
          "radial-gradient(ellipse 70% 50% at 50% 0%, rgba(124,58,237,0.35), transparent 65%), radial-gradient(ellipse 40% 30% at 90% 30%, rgba(168,85,247,0.18), transparent 70%), linear-gradient(180deg, #1A1527 0%, #09080F 100%)",
        fontFamily: "'Plus Jakarta Sans', 'Inter', sans-serif",
      }}
    >
      <Header />
      <div
        style={{
          width: "100%",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          background: "#0D0B14",
          backgroundImage:
            "radial-gradient(ellipse 50% 30% at 50% 0%, rgba(124,58,237,0.12), transparent 70%)",
          padding: "60px 16px 80px",
          borderRadius: "28px 28px 0 0",
          borderTop: "1px solid rgba(124, 58, 237, 0.22)",
          boxShadow: "0 -8px 40px rgba(0,0,0,0.4)",
          marginTop: "0",
        }}
      >
        {/* Section label */}
        <div
          style={{
            display: "inline-block",
            textTransform: "uppercase",
            letterSpacing: "0.12em",
            fontSize: "0.75rem",
            fontWeight: 700,
            color: "#7C3AED",
            padding: "0.375rem 0.875rem",
            borderRadius: "9999px",
            background: "rgba(124, 58, 237, 0.12)",
            border: "1px solid #E9E3FF",
            marginBottom: "1.25rem",
          }}
        >
          Partner Program
        </div>
        {/* Main Heading */}
        <h2
          style={{
            fontSize: "2.5rem",
            fontWeight: 800,
            textAlign: "center",
            color: "#F0ECF9",
            letterSpacing: "-0.035em",
            lineHeight: 1.1,
            marginTop: "0",
            marginBottom: "1rem",
            fontFamily: "'Plus Jakarta Sans', 'Inter', sans-serif",
          }}
        >
         Grow your business with{" "}
         <span
           style={{
             background: "linear-gradient(135deg, #7C3AED 0%, #A855F7 100%)",
             WebkitBackgroundClip: "text",
             WebkitTextFillColor: "transparent",
             backgroundClip: "text",
           }}
         >
           Zyppys
         </span>
        </h2>
        {/* Content Section */}
        <div
          style={{
            maxWidth: "780px",
            width: "100%",
            textAlign: "center",
          }}
        >
          <p
            style={{
              fontSize: "1.0625rem",
              marginTop: "12px",
              color: "rgba(255,255,255,0.6)",
              textAlign: "left",
              lineHeight: 1.7,
              fontWeight: 400,
              letterSpacing: "-0.005em",
              fontFamily: "'Plus Jakarta Sans', 'Inter', sans-serif",
            }}
          >
           Zyppys’s app and web portal seamlessly connect licensed and insured chauffeur partners with India's elite clientele of discerning business and leisure travelers. Whether you need to fill gaps in your schedule or seek a reliable primary ride source, we've got you covered. Our competitive pricing aligns with local market rates, and our steadfast commitment to quality ensures fair compensation for chauffeurs while delivering exceptional service to our guests.
          </p>

          {/* Full-Width Image */}
          <div
            style={{
              width: "100%",
              marginTop: "44px",
              borderRadius: "20px",
              overflow: "hidden",
              border: "1px solid #E9E3FF",
              boxShadow: "0 16px 48px rgba(124,58,237,0.18)",
            }}
          >
            <img
              src={carImage}
              alt="Car Sharing"
              style={{ width: "100%", height: "auto", display: "block" }}
            />
          </div>

          {/* Get Started Button */}
          {/* <div style={{ marginTop: "24px" }}>
            <a
              href="https://play.google.com/store/apps/details?id=com.zyppys.customer&hl=en"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                backgroundColor: "#a138de",
                color: "white",
                padding: "12px 24px",
                borderRadius: "8px",
                fontSize: "1rem",
                fontWeight: "600",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                textDecoration: "none",
              }}
            >
              Download App
            </a>
          </div> */}

          {/* Steps Section */}
          {/* <div style={{ marginTop: "32px", textAlign: "left" }}>
            
            <div style={{ marginTop: "24px" }}>
              <h3 style={{ fontSize: "2rem", fontWeight: "600" }}>
                Step 1: Sign Up & Verify Your Account
              </h3>
              <ul
                style={{
                  paddingLeft: "24px",
                  marginTop: "8px",
                  color: "#4b5563",
                  fontSize: "1.3rem",
                }}
              >
                <li>Download the host mobile app.</li>
                <li>Complete the registration.</li>
                <li>
                  Upload KYC documents (government ID, driver’s license, address
                  proof).
                </li>
              </ul>
            </div>

           
            <div style={{ marginTop: "24px" }}>
              <h3 style={{ fontSize: "2rem", fontWeight: "600" }}>
                Step 2: Check Host & Car Eligibility
              </h3>
              <p
                style={{
                  textAlign: "left",
                  fontSize: "1.3rem",
                  color: "#4b5563",
                }}
              >
                To list your car on Zyppys, you must meet the following
                criteria:
              </p>
              <h4
                style={{
                  fontSize: "1.3rem",
                  fontWeight: "600",
                  marginTop: "12px",
                }}
              >
                Host Requirements:
              </h4>
              <ul
                style={{
                  fontSize: "1.3rem",
                  paddingLeft: "24px",
                  color: "#4b5563",
                }}
              >
                <li>Must be at least 21 years old.</li>
                <li>
                  Own the car legally with valid registration & insurance.
                </li>
                <li>Agree to Zyppys' terms & conditions for car sharing.</li>
              </ul>
              <h4
                style={{
                  fontSize: "1.3rem",
                  fontWeight: "600",
                  marginTop: "16px",
                }}
              >
                Car Requirements:
              </h4>
              <ul
                style={{
                  fontSize: "1.3rem",
                  paddingLeft: "24px",
                  color: "#4b5563",
                }}
              >
                <li>
                  The car should be less than 7 years old and in good condition.
                </li>
                <li>
                  It must have valid registration (RC), insurance, and road
                  permits.
                </li>
                <li>
                  The vehicle should be clean, well-maintained, and roadworthy.
                </li>
              </ul>
            </div>

            
            <div style={{ marginTop: "24px" }}>
              <h3 style={{ fontSize: "2rem", fontWeight: "600" }}>
                Step 3: List Your Car on Zyppys
              </h3>
              <ul
                style={{
                  fontSize: "1.3rem",
                  paddingLeft: "24px",
                  color: "#4b5563",
                }}
              >
                <li>
                  Enter car details (brand, model, fuel type, transmission,
                  etc.).
                </li>
                <li>
                  Upload high-quality photos of your vehicle from multiple
                  angles.
                </li>
                <li>
                  Set your rental price, availability, and your own Terms &
                  Conditions.
                </li>
              </ul>
            </div>

            
            <div style={{ marginTop: "24px" }}>
              <h3 style={{ fontSize: "2rem", fontWeight: "600" }}>
                Step 4: Vehicle Inspection & Approval
              </h3>
              <ul
                style={{
                  fontSize: "1.3rem",
                  paddingLeft: "24px",
                  color: "#4b5563",
                }}
              >
                <li>
                  Zyppys will conduct a quick verification & quality check.
                </li>
                <li>
                  Once approved, your listing will go live on the platform for
                  renters to book.
                </li>
              </ul>
            </div>

            
            <div style={{ marginTop: "24px" }}>
              <h3 style={{ fontSize: "2rem", fontWeight: "600" }}>
                Step 5: Accept Bookings & Rent Your Car
              </h3>
              <ul
                style={{
                  fontSize: "1.3rem",
                  paddingLeft: "24px",
                  color: "#4b5563",
                }}
              >
                <li>
                  Receive rental requests via the Zyppys dashboard or mobile
                  app.
                </li>
                <li>Approve or decline bookings based on your availability.</li>
                <li>Offer pickup/drop-off at a preferred location.</li>
                <li>
                  Ensure the car is clean, fueled, and in good condition before
                  handing it over.
                </li>
              </ul>
            </div>

            
            <div style={{ marginTop: "24px" }}>
              <h3 style={{ fontSize: "2rem", fontWeight: "600" }}>
                Step 6: Earn & Get Paid
              </h3>
              <ul
                style={{
                  fontSize: "1.3rem",
                  paddingLeft: "24px",
                  color: "#4b5563",
                }}
              >
                <li>
                  Get payments directly from the customer during car pickup.
                </li>
                <li>
                  Zyppys takes a small commission (10-20%) depending on the plan
                  you choose.
                </li>
              </ul>
            </div>
          </div> */}

          {/* Why Host on Zyppys Section */}
          <div style={{ marginTop: "48px", textAlign: "left", width: "100%" }}>
            <div
              style={{
                display: "inline-block",
                textTransform: "uppercase",
                letterSpacing: "0.12em",
                fontSize: "0.75rem",
                fontWeight: 700,
                color: "#7C3AED",
                marginBottom: "0.5rem",
              }}
            >
              Why Zyppys
            </div>
            <h3
              style={{
                fontSize: "2rem",
                fontWeight: 800,
                color: "#F0ECF9",
                marginTop: "0",
                marginBottom: "0",
                letterSpacing: "-0.03em",
                lineHeight: 1.1,
                fontFamily: "'Plus Jakarta Sans', 'Inter', sans-serif",
              }}
            >
              Why Partner With Zyppys?
            </h3>
          </div>

          <ul
            style={{
              paddingLeft: "0",
              marginTop: "20px",
              color: "rgba(255,255,255,0.6)",
              textAlign: "left",
              fontSize: "1rem",
              listStyle: "none",
              width: "100%",
              fontFamily: "'Plus Jakarta Sans', 'Inter', sans-serif",
            }}
          >
            {[
              { title: "Access to a Premium Clientele", text: "Connect with India's elite business and leisure travelers, enhancing your visibility and reputation in the luxury market." },
              { title: "Robust Technology Platform", text: "Benefit from our user-friendly app and web portal, designed to streamline bookings and improve customer interactions." },
              { title: "Competitive Pricing Model", text: "Enjoy a pricing structure that is regularly aligned with local market rates, ensuring fair compensation while attracting more customers." },
              { title: "Commitment to Quality Service", text: "Join a network dedicated to delivering exceptional service, enhancing customer satisfaction and loyalty." },
              { title: "Marketing and Promotion Support", text: "Leverage our marketing efforts to increase your exposure and reach a broader audience, driving more bookings." },
              { title: "Reliable Payments", text: "Enjoy timely and secure payments, ensuring consistent cash flow and peace of mind for your business operations." },
            ].map((item, idx) => (
              <li
                key={idx}
                style={{
                  display: "flex",
                  gap: "1rem",
                  padding: "1.25rem 1.5rem",
                  marginBottom: "0.75rem",
                  background: "#13101E",
                  border: "1px solid rgba(124, 58, 237, 0.18)",
                  borderRadius: "16px",
                  transition: "all 0.25s ease",
                }}
              >
                <div
                  style={{
                    flexShrink: 0,
                    width: "6px",
                    borderRadius: "9999px",
                    background: "linear-gradient(180deg, #7C3AED 0%, #A855F7 100%)",
                  }}
                />
                <div>
                  <strong
                    style={{
                      display: "block",
                      fontWeight: 700,
                      color: "#F0ECF9",
                      fontSize: "1.0625rem",
                      letterSpacing: "-0.015em",
                      marginBottom: "0.375rem",
                    }}
                  >
                    {item.title}
                  </strong>
                  <span
                    style={{
                      color: "rgba(255,255,255,0.6)",
                      fontSize: "0.9375rem",
                      lineHeight: 1.65,
                      fontWeight: 400,
                    }}
                  >
                    {item.text}
                  </span>
                </div>
              </li>
            ))}
          </ul>

          <div
            style={{
              marginTop: "44px",
              padding: "1.75rem 2rem",
              background: "linear-gradient(135deg, rgba(124,58,237,0.15) 0%, rgba(168,85,247,0.1) 100%)",
              border: "1px solid rgba(124, 58, 237, 0.3)",
              borderRadius: "16px",
              textAlign: "center",
            }}
          >
            <strong
              style={{
                fontSize: "1.0625rem",
                color: "#C4B5FD",
                fontWeight: 600,
                lineHeight: 1.55,
                letterSpacing: "-0.01em",
                fontFamily: "'Plus Jakarta Sans', 'Inter', sans-serif",
              }}
            >
              Partnering with Zyppys can elevate your business and provide unparalleled opportunities for growth in the premium car rental market.
            </strong>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BecomeAHost;
